import React from 'react';
import { formatMetricDisplay, isMissingMetric, isOddCount, isOddPercent } from '../../../../common/functions';

const ChartResultList = ({ title = 'title', totalNumber, percentage }) => {
  const missing = isMissingMetric(totalNumber);
  const oddPct = isOddPercent(percentage);
  const oddCount = isOddCount(totalNumber);
  const hasQualityIssue = missing || oddPct || oddCount;
  const displayNumber = formatMetricDisplay(totalNumber);

  return (
    <React.Fragment>
      <div className='w-full md:w-1/2 mx-auto'>
        <div className="relative after:content-['.......................................'] after:ml-0.5 after:absolute after:top-0 after:left-1/2 after:-translate-x-1/2 after:text-black">
          <div className='flex justify-between  '>
            <span className='flex justify-between grow-1 text-base md:text-xl capitalize text-black font-semibold md:font-bold '>
              {title}
            </span>
            <span
              className={`grow-1 text-base md:text-xl capitalize font-semibold md:font-bold ${
                hasQualityIssue ? 'text-red-700' : 'text-black'
              }`}
              title={missing ? 'Missing value' : oddPct ? 'Odd percentage' : oddCount ? 'Odd value' : undefined}
            >
              {displayNumber}
              {oddPct && !isMissingMetric(percentage) ? ` (${percentage}%)` : ''}
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ChartResultList;
